export const load = () => ({
	title: 'Last Chance To Save With Free Shipping On Window Inserts',
	h1: 'Last Chance To Enjoy Free Shipping',
	description:
		'Now through December 31st, 2023, save hundreds with free shipping on standard orders. Talk to a Fit Specialist today to take advantage of big savings before free shipping expires!',
	showTitle: true,
});
